import { useEffect, useState } from 'react'
import { add } from 'date-fns'
import { isToday } from 'utils'
import PrimaryButton from './primaryButton'
import ModalContainer from './ModalContainer'
import { FilterInputs, listboxOptions } from './dateFilter'

// This filter modal is just for desktop
const FilterModal = ({
  isShown,
  setModalFunction,
  setDateRange,
  dateRange,
  filterFunction
}) => {
  const [customPeriod, setCustomPeriod] = useState({
    startDate: new Date(dateRange.created_from),
    endDate: dateRange.created_until
      ? new Date(dateRange.created_until)
      : new Date(),
    key: 'selection'
  })
  const [selectedPeriod, setSelectedPeriod] = useState(listboxOptions[0])
  const [isCalendarVisible, setCalendarVisible] = useState(false)

  useEffect(() => {
    if (isCalendarVisible) {
      const { startDate, endDate } = customPeriod

      const created_from = startDate
      const created_until = isToday(new Date(endDate))
        ? null
        : add(endDate, { days: 1 })

      setDateRange({ created_from, created_until })
    }
  }, [customPeriod, isCalendarVisible])

  useEffect(() => {
    if (isShown) {
      setDateRange({
        created_from: add(new Date(), { weeks: -1 }),
        created_until: null
      })
    }
  }, [isShown])

  const clearSelection = () => {
    setModalFunction(false)
    setCalendarVisible(false)
    setCustomPeriod({
      startDate: new Date(dateRange.created_from),
      endDate: dateRange.created_until
        ? new Date(dateRange.created_until)
        : new Date(),
      key: 'selection'
    })
    setSelectedPeriod(listboxOptions[0])
  }

  return (
    <ModalContainer
      title='Filtrar Movimientos'
      isShown={isShown}
      setModalFunction={setModalFunction}
      className={`!max-w-[43rem] ${
        isCalendarVisible ? '!w-[43rem]' : '!w-[28rem]'
      }`}
    >
      <div
        id='modal-layout'
        className={`w-full mb-4 h-full ${
          isCalendarVisible && 'flex gap-2 flex-row mb-0'
        }`}
      >
        <FilterInputs
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          customPeriod={customPeriod}
          setDateRange={setDateRange}
          setCalendarVisible={setCalendarVisible}
          isCalendarVisible={isCalendarVisible}
          setCustomPeriod={setCustomPeriod}
        />
      </div>
      <div className='border-t border-solid border-gray-500 mb-6 mt-3' />
      <div className='flex mt-auto justify-between gap-12'>
        <PrimaryButton
          buttonText='Cancelar'
          primaryButtonFunction={() => {
            clearSelection()
          }}
          outlined
        />
        <PrimaryButton
          buttonText='Filtrar'
          primaryButtonFunction={() => {
            filterFunction()
            clearSelection()
          }}
        />
      </div>
    </ModalContainer>
  )
}

export default FilterModal
